import styled from 'styled-components';

export default styled.div`
  color: ${({ color }) => color || '#c5cede'};
  margin-bottom: 5px;
  font-size: 12px;
`;
